import * as Dialog from "@radix-ui/react-dialog";
import { Link2, Upload, X } from "lucide-react";

interface VideoSourceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpload: () => void;
  onPasteLink: () => void;
}

export function VideoSourceModal({
  open,
  onOpenChange,
  onUpload,
  onPasteLink,
}: VideoSourceModalProps) {
  const handleUpload = () => {
    onUpload();
    onOpenChange(false);
  };

  const handlePasteLink = () => {
    onPasteLink();
    onOpenChange(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50" />
        <Dialog.Content className="fixed left-[50%] top-[50%] z-50 w-full max-w-sm translate-x-[-50%] translate-y-[-50%] rounded-lg border border-border bg-card shadow-2xl">
          {/* Header */}
          <div className="border-b border-border p-5">
            <Dialog.Title className="text-lg font-semibold text-foreground">Add Video</Dialog.Title>
            <p className="mt-1 text-sm text-muted-foreground">Choose how you want to add a video</p>
          </div>

          {/* Buttons */}
          <div className="space-y-3 p-5">
            <button
              type="button"
              onClick={handleUpload}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-transparent bg-primary px-4 py-3 font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            >
              <Upload className="h-5 w-5" />
              Upload Video File
            </button>

            <button
              type="button"
              onClick={handlePasteLink}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-border bg-secondary px-4 py-3 font-medium text-foreground transition-colors hover:bg-secondary/80 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            >
              <Link2 className="h-5 w-5" />
              Paste YouTube or Video Link
            </button>
          </div>

          {/* Close button */}
          <Dialog.Close className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-md transition-colors hover:bg-secondary focus:outline-none">
            <X className="h-4 w-4" />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
